import React, { Component } from 'react';
import browserStorage from '../../common/services/browserStorage';

class AuthorizationRedirect extends Component {
	componentDidMount() {
		const { franchisor, franchiseeId, centerId } = this.props;
		// store required data in local storage and pass the local storage key as Zoom state param
		const storedData = {
			franchiseeId,
			centerId
		};
		const storedDataKey = Math.random().toString(36).substr(2);
		browserStorage.setToSessionStorage(franchisor, storedDataKey, JSON.stringify(storedData));

		const authorizeUrl = 'https://zoom.us/oauth/authorize';
		const clientId = franchisor.zoomClientId;
		const redirectUrl = franchisor.zoomOAuthRedirectUrl;

		window.location = `${authorizeUrl}?client_id=${clientId}` +
			'&response_type=code' +
			`&redirect_uri=${encodeURIComponent(redirectUrl)}` +
			`&state=${franchisor.id}.${encodeURIComponent(storedDataKey)}`;
	}

	render() {
		return <div>Redirecting...</div>;
	}
}

export default AuthorizationRedirect;